<template>
  <div class="child-product-mgmt-page purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>产品管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/client/parentProductMgmt' }">父产品管理</el-breadcrumb-item>
        <el-breadcrumb-item>子商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">颜色</span>
            <el-select placeholder="全部" size="small" v-model="filterColor" clearable filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in filterColorOptions" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="filterModel" clearable filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in filterModelOptions" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">父产品</span>
            <span class="product-summary">{{ parentProductSummary }}</span>
          </div>
          <div class="filter-item">
            <span class="filter-label">父商品Asin</span>
            <span class="product-summary">{{ parentProductAsinText }}</span>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">当前 {{ products.length }} 条 / 共 {{ allProducts.length }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getProducts">查询</el-button>
            <el-button type="primary" size="small" plain @click="batchUpdateProductPrice">批量改价</el-button>
            <el-button size="small" @click="resetUpdateStatus">重置修改</el-button>
            <el-button size="small" @click="editStockCycle">编辑备货周期</el-button>
            <el-button size="small" plain>
              <download-excel :data="productData" :fields="productTitles" :name="getExportProductName()">导出商品</download-excel>
            </el-button>
            <el-button size="small" plain @click="openParentProductAsin">设置父Asin</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="products" border stripe size="small" :height="screenHeight" class="mgmt-table child-product-table" header-cell-class-name="table-header-cell" show-summary v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
          <el-table-column label="序号" width="52" align="center">
            <template slot-scope="scope">
              {{ beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productColorName" label="颜色" width="72" align="center" sortable></el-table-column>
          <el-table-column prop="model" label="机型" width="92" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="seller-sku" label="SKU" min-width="200" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="parentAsin" label="父Asin" width="108" sortable show-overflow-tooltip>
            <template slot-scope="scope">
              <span :class="{ redText: isParentAsinMismatch(scope.row) }">{{ scope.row.parentAsin }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="asin" label="Asin" width="108" sortable show-overflow-tooltip></el-table-column>
          <el-table-column label="材料组合" min-width="180" sortable show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="material-config-cell">{{ getMaterialConfigText(scope.row.materialConfig) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="售价" width="72" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="netIncome" label="毛利" width="72" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              {{ getNetIncome(scope.row).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="毛利率" width="80" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              {{ getGrossMargin(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="purchaseCost" label="采购成本" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="fbaFee" label="FBA配送费" width="88" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column label="亚马逊抽佣" width="88" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              {{ (scope.row.price * 0.15).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="分拣费" width="72" align="right" sortable class-name="amount-col">0.00</el-table-column>
          <el-table-column label="头程费" width="72" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              {{ scope.row.firstMileFee.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="备货类型" width="92" align="center" sortable>
            <template slot-scope="scope">
              <el-tag :type="getStockCycleTagType(scope.row.stockCycleType)" size="mini" effect="plain">
                {{ getStockCycleLabel(scope.row.stockCycleType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="localStockCycle" label="本地库存周期" width="96" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="stockCycleAdjustRate" label="备货调整" width="88" align="right" sortable class-name="amount-col">
            <template slot-scope="scope">
              {{ (scope.row.stockCycleAdjustRate != undefined ? scope.row.stockCycleAdjustRate : 0) + "%" }}
            </template>
          </el-table-column>
          <el-table-column label="竞品Asin" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.competitorAsins ? scope.row.competitorAsins.join(",") : "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="220" fixed="right" align="center" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="small" @click="editProduct(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="configCompetitorAsin(scope.row)">配置竞品</el-button>
                <el-button type="text" size="small" @click="keywordAnalyze(scope.row)">关键词分析</el-button>
                <el-button type="text" size="small" @click="configMaterial(scope.row)">配置材料</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="批量修改价格" :visible.sync="parentProductDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label"><span>*</span>型号</span>
        <el-select placeholder="机型" size="small" v-model="batchParams.modelType">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="batchParams.colorType">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>售价</span>
        <el-input class="form-input" placeholder="请输入" v-model="batchParams.price" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>是否跳过清库存</span>
        <el-radio v-model="batchParams.skipClearInventory" :label="1">是</el-radio>
        <el-radio v-model="batchParams.skipClearInventory" :label="0">否</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="parentProductDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑备货周期" :visible.sync="stockCycleDialogVisible" :close-on-click-modal="false" width="800px">
      <div class="form-line">
        <span class="form-label"><span>*</span>备货类型</span>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="1">平销</el-radio>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="2">做排名</el-radio>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="3">新品推广</el-radio>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="4">清库存</el-radio>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="5">禁止采购</el-radio>
        <el-radio v-model="stockCycleParams.stockCycleType" :label="6">禁止出库</el-radio>
      </div>
      <template v-if="stockCycleParams.sku != ''">
        <div class="form-line">
          <span class="form-label"><span>*</span>SKU</span>
          <span class="form-text">{{ stockCycleParams.sku }}</span>
        </div>
      </template>
      <template v-if="stockCycleParams.sku == ''">
        <div class="form-line">
          <span class="form-label"><span>*</span>型号</span>
          <el-select placeholder="机型（可多选，不选为全部）" size="small" v-model="stockCycleParams.modelType" style="width: 300px" multiple collapse-tags filterable clearable>
            <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>颜色</span>
          <el-select placeholder="产品类型" size="small" v-model="stockCycleParams.colorType" style="width: 300px" filterable clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="color in stockCycleColorOptions" :key="color.key" :label="color.name" :value="color.key"></el-option>
          </el-select>
        </div>
      </template>
      <div class="form-line" v-if="stockCycleParams.stockCycleType == 2 || stockCycleParams.stockCycleType == 3">
        <span class="form-label"><span>*</span>运营周期</span>
        <el-date-picker v-model="stockCycleParams.dateRange" type="daterange" style="width: 300px" size="small" firstDayOfWeek="1" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"> </el-date-picker>
      </div>
      <!-- <div class="form-line" v-if="stockCycleParams.stockCycleType == 2 || stockCycleParams.stockCycleType == 3">
        <span class="form-label"><span>*</span>每日预算</span>
        <el-input class="form-input" placeholder="请输入" v-model="stockCycleParams.dayBudget" size="small" style="width: 300px" clearable> </el-input>
      </div> -->
      <div class="form-line" v-if="stockCycleParams.stockCycleType != 4 && stockCycleParams.stockCycleType != 6">
        <span class="form-label"><span>*</span>本地备货周期</span>
        <el-input class="form-input" placeholder="请输入" v-model="stockCycleParams.localStockCycle" size="small" style="width: 300px" clearable> </el-input>
      </div>
      <div class="form-line" v-if="stockCycleParams.stockCycleType != 4 && stockCycleParams.stockCycleType != 6">
        <span class="form-label"><span>*</span>备货调整百分比</span>
        <el-input class="form-input" placeholder="请输入" v-model="stockCycleParams.stockCycleAdjustRate" size="small" style="width: 300px" clearable> </el-input>
        <span class="form-label" style="text-align: left; margin-left: 5px">%</span>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>是否跳过清库存</span>
        <el-radio v-model="stockCycleParams.skipClearInventory" :label="1">是</el-radio>
        <el-radio v-model="stockCycleParams.skipClearInventory" :label="0">否</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="stockCycleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleStockCycleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="600px" title="配置材料组合" :visible.sync="configMaterialDialogVisible" append-to-body>
      <div v-for="(config, index) in materialConfig" class="form-line">
        <span class="form-label"><span>*</span>材料{{ index + 1 }}</span>
        <el-select class="form-select" placeholder="请选择" size="small" v-model="config.materialColor" style="margin-right: 30px; vertical-align: middle" filterable>
          <el-option v-for="item in materialColorLists" :label="item.materialName" :value="item.materialColor"></el-option>
        </el-select>

        <span style="margin-right: 10px">数量</span>
        <el-input class="form-input" placeholder="请输入" v-model.number="config.count" size="small" type="number" style="width: 100px; vertical-align: middle; margin-right: 10px" clearable> </el-input>
        <span>个</span>

        <el-button type="text" @click="deleteMateral(index)" :data-index="index" style="margin-left: 10px">- 删除</el-button>
      </div>
      <div class="form-line">
        <el-button @click="addOneMaterial" type="text" style="margin-left: 90px">+ 新增材料</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configMaterialDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfigMaterialConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="600px" title="设置父Asin" :visible.sync="parentProductAsinDialogVisible" :close-on-click-modal="false" append-to-body>
      <div class="form-line">
        <span class="form-label">父Asin</span>
        <el-input class="form-input" placeholder="请输入" v-model="parentProductAsinInput" size="small" style="width: 300px" clearable></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="parentProductAsinDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmParentProductAsin">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="600px" title="配置竞品" :visible.sync="configCompetitorAsinDialogVisible" append-to-body>
      <div class="form-line">
        <span class="form-label">竞品Asins</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorAsins" size="small" style="width: 300px" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configCompetitorAsinDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCompetitorAsinConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, models, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      configMaterialDialogVisible: false,
      configCompetitorAsinDialogVisible: false,
      screenHeight: 400,
      loading: false,
      beginIndex: 0,
      productType: this.$route.query.productType,
      colorList: colors,
      modelList: models,
      batchParams: {
        modelType: "",
        colorType: "",
        skipClearInventory: 1,
      },
      stockCycleParams: {
        sku: "",
        modelType: [],
        colorType: "",
        // dayBudget: 0,
        dateRange: "",
        stockCycleType: 1,
        localStockCycle: 2,
        stockCycleAdjustRate: 0,
        skipClearInventory: 1,
      },
      colors: colors,
      models: [],
      iPhoneModels: iPhoneModels,
      productLists: products,
      checkedModels: [],
      checkedColors: [],
      productInfo: {
        productName: "",
        skuPrefix: "",
        skuPrefix2: "",
        title: "",
        des1: "",
        des2: "",
        des3: "",
        des4: "",
        des5: "",
        des6: "",
        des7: "",
        des8: "",
        des9: "",
        des10: "",
        checkColors: [],
        checkModels: [],
        defaultModel: "",
        defaultColor: "",
        defaultColorName: "",
        cost: 1.2,
        shopType: 1,
        status: 1,
        categoryType: 1,
        isHasModel: 1,
      },
      parentProductDialogVisible: false,
      parentProductAsinDialogVisible: false,
      parentProductAsinInput: "",
      stockCycleDialogVisible: false,
      colorDialogVisible: false,
      parentProduct: null,
      allProducts: [],
      products: [],
      filterColor: "",
      filterModel: "",
      exportProducts: [],
      multipleSelection: [],
      colorInfo: {
        name: "",
        key: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      materialConfig: [],
      materials: [],
      competitorAsins: "",
    };
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  mounted() {
    this.getProducts();
    this.getAllProducts();
    this.getParentProduct();
    this.fetchMaterials();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - 8;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    getNetIncome(row) {
      return row.price - row.price * 0.15 - row.fbaFee - row.purchaseCost - row.firstMileFee;
    },
    getGrossMargin(row) {
      if (!row.price) {
        return "-";
      }
      return ((this.getNetIncome(row) / row.price) * 100).toFixed(2) + "%";
    },
    getStockCycleTagType(stockCycleType) {
      if (stockCycleType == 2 || stockCycleType == 3) {
        return "success";
      }
      if (stockCycleType == 4) {
        return "warning";
      }
      if (stockCycleType == 5 || stockCycleType == 6) {
        return "danger";
      }
      return "";
    },
    deleteMateral(index) {
      this.materialConfig.splice(index, 1);
    },
    parseMaterialConfig(materialConfig) {
      if (!materialConfig) {
        return [{ materialColor: "", materialId: "", color: "", count: 1 }];
      }

      let list = materialConfig;
      if (typeof list === "string") {
        try {
          list = JSON.parse(list);
        } catch (error) {
          return [{ materialColor: "", materialId: "", color: "", count: 1 }];
        }
      }

      if (!Array.isArray(list) || list.length === 0) {
        return [{ materialColor: "", materialId: "", color: "", count: 1 }];
      }

      return list.map(config => {
        const item = {
          materialId: config.materialId || "",
          color: config.color || "",
          count: config.count || 1,
          materialColor: config.materialColor || "",
        };
        if (!item.materialColor && item.materialId) {
          item.materialColor = item.color ? `${item.materialId}-${item.color}` : String(item.materialId);
        }
        return item;
      });
    },
    buildMaterialConfigForSave(materialConfig) {
      return materialConfig.map(config => {
        const item = {
          materialId: config.materialId || "",
          color: config.color || "",
          count: Number(config.count) || 1,
        };

        if (config.materialColor) {
          const parts = String(config.materialColor).split("-");
          item.materialId = parts[0] || item.materialId;
          item.color = parts.length > 1 ? parts.slice(1).join("-") : item.color;
        }

        return item;
      });
    },
    getMaterialConfigText(materialConfig) {
      if (!materialConfig) {
        return "";
      }

      let list = materialConfig;
      if (typeof list === "string") {
        try {
          list = JSON.parse(list);
        } catch (error) {
          return "";
        }
      }

      if (!Array.isArray(list)) {
        return "";
      }

      let txt = "";
      list.forEach((config, index) => {
        txt += "材料" + ++index + "：" + this.getMaterialName(config.materialId);
        config.color && config.color != "" && (txt += "-" + this.getColorLabel(config.color));
        txt += "- " + config.count + "个；";
      });
      return txt;
    },
    getMaterialName(materialId) {
      let material = this.materials.find(m => m.materialId == materialId);
      return material ? material.materialName : "";
    },
    getMaterialColorName(materialId) {
      let material = this.materials.find(m => m.materialId == materialId);
      return material ? material.colorName : "";
    },
    fetchMaterials() {
      requestModules
        .fetchMaterials({ pageSize: 10000 })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.materials = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    addOneMaterial() {
      this.materialConfig.push({
        materialColor: "",
        materialId: "",
        color: "",
        count: 1,
      });
    },
    configMaterial(row) {
      this.productInfo = { ...row };
      this.configMaterialDialogVisible = true;
      this.materialConfig = this.parseMaterialConfig(row.materialConfig);
    },
    configCompetitorAsin(row) {
      this.productInfo = { ...row };
      this.configCompetitorAsinDialogVisible = true;
      this.competitorAsins = row.competitorAsins.join(",");
    },
    handleCompetitorAsinConfirmBtn() {
      this.configCompetitorAsinDialogVisible = false;
      let competitorAsins = this.competitorAsins.split(",");
      requestModules
        .configCompetitorAsins({ asin: this.productInfo.asin, competitorAsins: JSON.stringify(competitorAsins) })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleConfigMaterialConfirmBtn() {
      const normalizedConfig = this.buildMaterialConfigForSave(this.materialConfig);
      if (normalizedConfig.some(config => !config.materialId)) {
        this.$message({
          type: "error",
          message: "请完整选择材料",
        });
        return;
      }

      this.configMaterialDialogVisible = false;

      let cost = 0;
      normalizedConfig.forEach(config => {
        let material = this.materials.find(m => m.materialId == config.materialId);
        let tempCost = 0;

        if (material) {
          let supplier1Price = material.supplier1Price > 0 ? material.supplier1Price : 0;
          let supplier2Price = material.supplier2Price > 0 ? material.supplier2Price : 0;
          let supplier3Price = material.supplier3Price > 0 ? material.supplier3Price : 0;

          if (material.mainSupplierId) {
            material.supplier1Id == material.mainSupplierId && (tempCost = supplier1Price);
            material.supplier2Id == material.mainSupplierId && (tempCost = supplier2Price);
            material.supplier3Id == material.mainSupplierId && (tempCost = supplier3Price);
          } else {
            supplier1Price > 0 && (tempCost = supplier1Price);
            supplier2Price > 0 && (tempCost = supplier2Price);
            supplier3Price > 0 && (tempCost = supplier3Price);

            supplier2Price > 0 && tempCost > supplier2Price && (tempCost = supplier2Price);
            supplier3Price > 0 && tempCost > supplier3Price && (tempCost = supplier3Price);
          }

          tempCost == 0 && (tempCost = material.cost);
          cost += tempCost * config.count;
        }
      });

      let product = { ...this.productInfo };
      product.materialConfig = JSON.stringify(normalizedConfig);
      product.purchaseCost = parseFloat((cost / 7.1).toFixed(2));

      requestModules
        .configProductMaterial(product)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStockCycleLabel(stockCycleType) {
      let label = "";
      stockCycleType == 1 && (label = "平销");
      stockCycleType == 2 && (label = "做排名");
      stockCycleType == 3 && (label = "新品推广");
      stockCycleType == 4 && (label = "清库存");
      stockCycleType == 5 && (label = "禁止采购");
      stockCycleType == 6 && (label = "禁止出库");
      return label;
    },
    getParentProduct() {
      if (!this.productType) {
        return;
      }
      requestModules.fetchParentProducts({ productType: this.productType }).then(res => {
        this.parentProduct = (res.ldata && res.ldata[0]) || null;
      });
    },
    isParentAsinMismatch(row) {
      const current = String((this.parentProduct && this.parentProduct.parentAsin) || "").trim();
      const rowAsin = String((row && row.parentAsin) || "").trim();
      return rowAsin !== current;
    },
    editStockCycle() {
      this.stockCycleDialogVisible = true;
      this.stockCycleParams.sku = "";
      this.stockCycleParams.modelType = [];
      this.stockCycleParams.colorType = "";
    },
    handleStockCycleConfirmBtn() {
      if (this.stockCycleParams.dateRange && this.stockCycleParams.dateRange.length > 1) {
        this.stockCycleParams.startDate = this.stockCycleParams.dateRange[0].format("yyyy-MM-dd");
        this.stockCycleParams.endDate = this.stockCycleParams.dateRange[1].format("yyyy-MM-dd");
      }

      let productList = this.products;

      if (this.stockCycleParams.sku != "") {
        productList = productList.filter(pd => pd["seller-sku"] == this.stockCycleParams.sku);
      } else {
        let blankReg = new RegExp(" ", "igm");
        let modelList = (this.stockCycleParams.modelType || []).map(m => m.replace(blankReg, ""));
        this.stockCycleParams.colorType != "" && (productList = productList.filter(pd => pd.productColor == this.stockCycleParams.colorType));
        modelList.length > 0 && (productList = productList.filter(pd => modelList.indexOf(pd.model) > -1));
      }
      let updateList = [];

      for (let i = 0; i < productList.length; i++) {
        // productList.forEach(pd => {
        let pd = productList[i];
        if (this.stockCycleParams.skipClearInventory == 1 && pd.stockCycleType == 4) {
          continue;
        }
        updateList.push({
          asin: pd.asin,
          // dayBudget: this.stockCycleParams.dayBudget,
          startDate: this.stockCycleParams.startDate,
          endDate: this.stockCycleParams.endDate,
          stockCycleType: this.stockCycleParams.stockCycleType,
          localStockCycle: this.stockCycleParams.stockCycleType == 4 ? 0 : this.stockCycleParams.localStockCycle,
          stockCycleAdjustRate: this.stockCycleParams.stockCycleAdjustRate,
          skipClearInventory: this.stockCycleParams.skipClearInventory,
        });
      }
      requestModules
        .batchUpdateStockCycle({ productList: JSON.stringify(updateList) })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
        });
      this.stockCycleDialogVisible = false;
    },
    getProducts() {
      this.loading = true;
      requestModules
        .fetchProducts({ productType: this.productType, beginIndex: 0, pageSize: 1000 })
        .then(res => {
          this.allProducts = res.ldata || [];
          this.allProducts.sort((a, b) => (b["seller-sku"] > a["seller-sku"] ? -1 : 1));
          this.applyFilter();
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    applyFilter() {
      let list = this.allProducts;
      if (this.filterColor) {
        list = list.filter(item => item.productColor == this.filterColor);
      }
      if (this.filterModel) {
        list = list.filter(item => item.model == this.filterModel);
      }
      this.products = list;
    },
    getAllProducts() {
      requestModules.fetchProducts({ opreate: "Update", beginIndex: 0, pageSize: 10000 }).then(res => {
        this.exportProducts = res.ldata;
      });
    },
    batchUpdateProductPrice() {
      this.parentProductDialogVisible = true;
    },
    openParentProductAsin() {
      if (!this.productType) {
        this.$message({
          type: "warning",
          message: "缺少父产品类型",
        });
        return;
      }
      this.parentProductAsinInput = (this.parentProduct && this.parentProduct.parentAsin) || "";
      this.parentProductAsinDialogVisible = true;
    },
    confirmParentProductAsin() {
      const parentAsin = (this.parentProductAsinInput || "").trim();
      if (!parentAsin) {
        this.$message({
          type: "warning",
          message: "请输入父Asin",
        });
        return;
      }
      requestModules
        .setParentProductAsin({ productType: this.productType, parentAsin })
        .then(res => {
          this.parentProductAsinDialogVisible = false;
          if (this.parentProduct) {
            this.$set(this.parentProduct, "parentAsin", res.mdata && res.mdata.parentAsin ? res.mdata.parentAsin : parentAsin);
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: (err && err.message) || "设置失败",
          });
        });
    },
    resetUpdateStatus() {
      this.$confirm("是否确认回复产品变更状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          requestModules
            .resetProductStatus()
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "重置失败",
                });
                return;
              }
              this.$message({
                type: "success",
                message: "重置成功!",
              });
              this.getProducts();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    editProduct(row) {
      this.stockCycleDialogVisible = true;
      this.stockCycleParams.sku = row["seller-sku"];
    },
    handleConfirmBtn() {
      let productList = this.products;
      this.batchParams.colorType != "" && (productList = productList.filter(pd => pd.productColor == this.batchParams.colorType));
      this.batchParams.modelType != "" && (productList = productList.filter(pd => pd.model == this.batchParams.model));
      this.batchParams.skipClearInventory && (productList = productList.filter(pd => pd.stockCycleType != 4));

      let updateList = [];
      productList.forEach(pd =>
        updateList.push({
          asin: pd.asin,
          price: this.batchParams.price,
        })
      );
      console.log(JSON.stringify(updateList));

      this.parentProductDialogVisible = false;
      requestModules
        .batchUpdateProductPrice({ productList: JSON.stringify(updateList) })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    keywordAnalyze(row) {
      window.open("/client/parentProductMgmt/productKeywordAnalyze?productType=" + row.productType + "&sku=" + row["seller-sku"]);
    },
    getShopName(shopType) {
      let shopName = "灵柚";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 5 && (shopName = "杭傲");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    getStockCycleStyleClass(stockCycleType) {
      return stockCycleType == 4 || stockCycleType == 5 || stockCycleType == 6 ? "redText" : "";
    },
    getColorName(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color && color.name;
    },
    getExportProductName() {
      return "产品描述_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getColorLabel(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color ? color.name : "";
    },
  },
  computed: {
    stockCycleColorOptions() {
      if (!this.parentProduct || !this.parentProduct.purchaseColors) {
        return [];
      }
      let purchaseColors = this.parentProduct.purchaseColors;
      if (!Array.isArray(purchaseColors)) {
        try {
          purchaseColors = JSON.parse(purchaseColors);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(purchaseColors)) {
        return [];
      }
      return purchaseColors
        .map(pc => {
          let color = this.colors.find(c => c.key == pc.productColor);
          return {
            key: pc.productColor,
            name: color ? color.name : pc.purchaseColorName || pc.productColor,
          };
        })
        .filter(color => color.key);
    },
    filterColorOptions() {
      const map = new Map();
      this.allProducts.forEach(item => {
        if (item.productColor) {
          map.set(item.productColor, item.productColorName || item.productColor);
        }
      });
      return Array.from(map, ([key, name]) => ({ key, name })).sort((a, b) => a.name.localeCompare(b.name, "zh-CN"));
    },
    filterModelOptions() {
      return [...new Set(this.allProducts.map(item => item.model).filter(Boolean))].sort((a, b) => a.localeCompare(b, "zh-CN"));
    },
    parentProductAsinText() {
      const asin = this.parentProduct && this.parentProduct.parentAsin;
      return asin ? asin : "-";
    },
    parentProductSummary() {
      if (this.allProducts.length > 0 && this.allProducts[0].productName) {
        return `类型 ${this.productType} · ${this.allProducts[0].productName}`;
      }
      let product = this.productLists.find(item => item.productType == this.productType);
      if (product && product.productName) {
        return `类型 ${this.productType} · ${product.productName}`;
      }
      return this.productType ? `类型 ${this.productType}` : "-";
    },
    productTitles() {
      let fields = {
        "店铺名称": "shopName",
        "产品名称": "productName",
        "颜色": "productColorName",
        "机型": "model",
        "SKU": "seller-sku",
        "价格": "price",
      };
      return fields;
    },
    productData() {
      // let list = [];
      // this.exportProducts.forEach(pd => list.push({
      //   sku :pd["seller-sku"],
      //   price: pd.price
      // }))
      return this.exportProducts;
    },
    materialColorLists() {
      let list = [];
      this.materials.forEach(material => {
        if (material.colorList && material.colorList.length > 0) {
          material.colorList.forEach(color => {
            list.push({
              materialId: material.materialId,
              materialName: material.materialName + "-" + this.getColorLabel(color),
              color: color,
              materialColor: material.materialId + "-" + color,
            });
          });
        } else {
          list.push({
            materialId: material.materialId,
            materialName: material.materialName + "-" + this.getColorLabel(material.colorType),
            materialColor: material.materialId + "-" + material.colorType,
          });
        }
      });
      return list;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.child-product-mgmt-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 1;
      font-size: 13px;
    }
  }

  .header-box {
    padding: 10px;

    .product-summary {
      color: #303133;
      font-size: 13px;
      font-weight: 500;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .child-product-table {
    .table-header-cell {
      padding: 8px 0;
      line-height: 1.45;
      white-space: normal;
      word-break: break-word;
    }

    th .cell {
      padding: 8px 10px;
      line-height: 1.45;
    }

    .cell {
      padding-left: 10px;
      padding-right: 10px;
      line-height: 20px;
    }
  }

  .material-config-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .action-cell {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 2px 4px;
    white-space: normal;
    line-height: 1.4;

    .el-button--text {
      padding: 0 4px;
      margin: 0;
    }
  }

  .redText {
    color: #f56c6c;
  }

  .form-line {
    height: auto;
    min-height: 40px;
    line-height: 40px;

    .form-label {
      margin: 5px 10px 5px 0px;
      width: 110px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }
}

.form-line {
  .form-label {
    margin: 5px 10px 5px 0px;
    width: 80px;
    text-align: right;
    display: inline-block;
    span {
      color: red;
    }
  }
  .form-input {
    width: 800px;
    margin: 5px 0px;
    vertical-align: top;
  }
  .form-group {
    width: 750px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .el-checkbox {
      width: 70px;
    }
    .el-radio {
      width: 70px;
    }
  }
}
</style>
